/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Route } from 'vue-router';

const routes = [
  { path: '/embeddables/:id', name: 'embeddable', component: () => import(/* webpackChunkName: "Embeddable" */ '../views/Embeddable.vue'), props: true },
  {
    path: '/artifacts/:id',
    name: 'artifacts',
    props: true,
    beforeEnter: (to: Route): void => {
      window.location.replace(`/#/artifacts/${to.params.id}`);
    }
  }
];

export { routes };
